import React from "react";
import { Box, Typography } from "@mui/material";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";
import theme from "../theme";
import Marquee from "react-fast-marquee";
import Image1 from "../Asset/Images/Affilations/Affilations (4).svg";
import Image2 from "../Asset/Images/Affilations/Affilations (2).svg";
import Image3 from "../Asset/Images/Affilations/Affilations (1).svg";
import Image4 from "../Asset/Images/Affilations/Affilations (3).svg";
import Image5 from "../Asset/Images/Affilations/Affilations (5).svg";
import Image6 from "../Asset/Images/Affilations/Affilations (6).svg";
import Image7 from "../Asset/Images/Affilations/Affilations (7).svg";

const affiliations = [
  { src: Image1, alt: "AgeTech Collaborative" },

  { src: Image7, alt: "DHNY" },
  { src: Image4, alt: "Startup Health" },

  { src: Image2, alt: "Global Wellness Ambassador" },
  { src: Image3, alt: "Chronic Disease Directors" },

  { src: Image6, alt: "WMG" },
  { src: Image5, alt: "The Well" },
];

const AffiliationsCarousel = () => {
  return (
    <Box
      sx={{
        background: "#F3F8FE",
        py: { md: 15, sm: 5, xs: 2 },
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
      }}
    >
      <Typography
        variant="h5"
        fontWeight="bold"
        sx={{
          mb: 6,
          fontFamily: theme.fonts.secondary,
          color: "#0a2342",
        }}
      >
        COLLABORATIONS
      </Typography>

      <Box
        sx={{
          width: "100%",
          overflow: "hidden",
          pl: { xs: 1, sm: 2, md: 0 },
          pr: { xs: 1, sm: 2, md: 0 },
          maxWidth: "1500px",
        }}
      >
        <Marquee
          gradient={false}
          speed={40} // adjust speed as you like
          pauseOnHover={false}
        >
          {affiliations.map((item, index) => (
            <Box
              key={index}
              sx={{
                p: 2,
                mx: 1,
                borderRadius: 4,
                border: `1px solid ${theme.palette.primary.main}`,
                height: "180px",
                width: "250px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexShrink: 0, // prevent shrinking
              }}
            >
              <Box
                component="img"
                src={item.src}
                alt={item.alt}
                sx={{
                  maxWidth: "150px",
                  maxHeight: "150px",
                  objectFit: "cover",
                }}
              />
            </Box>
          ))}
        </Marquee>
      </Box>
    </Box>
  );
};

export default AffiliationsCarousel;
